/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgreementsControllerFindByTypeQueryResponse, AgreementsControllerFindByTypePathParams, AgreementsControllerFindByType401, AgreementsControllerFindByType404 } from "../../models/agreementsController/AgreementsControllerFindByType";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { agreementsControllerFindByType } from "../../clients/agreementsService/agreementsControllerFindByType";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const agreementsControllerFindByTypeQueryKey = (type: AgreementsControllerFindByTypePathParams["type"]) => [{
  url: '/api/v1/agreements/:type',
  params: {
    type: type
  }
}] as const;
export type AgreementsControllerFindByTypeQueryKey = ReturnType<typeof agreementsControllerFindByTypeQueryKey>;
export function agreementsControllerFindByTypeQueryOptions(type: AgreementsControllerFindByTypePathParams["type"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = agreementsControllerFindByTypeQueryKey(type);
  return queryOptions<AgreementsControllerFindByTypeQueryResponse, ResponseErrorConfig<AgreementsControllerFindByType401 | AgreementsControllerFindByType404>, AgreementsControllerFindByTypeQueryResponse, typeof queryKey>({
    enabled: !!type,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return agreementsControllerFindByType(type, config);
    }
  });
}

/**
 * @summary Get active agreement by type
 * {@link /api/v1/agreements/:type}
 */
export function useAgreementsControllerFindByType<TData = AgreementsControllerFindByTypeQueryResponse, TQueryData = AgreementsControllerFindByTypeQueryResponse, TQueryKey extends QueryKey = AgreementsControllerFindByTypeQueryKey>(type: AgreementsControllerFindByTypePathParams["type"], options: {
  query?: Partial<QueryObserverOptions<AgreementsControllerFindByTypeQueryResponse, ResponseErrorConfig<AgreementsControllerFindByType401 | AgreementsControllerFindByType404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? agreementsControllerFindByTypeQueryKey(type);
  const query = useQuery({
    ...agreementsControllerFindByTypeQueryOptions(type, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AgreementsControllerFindByType401 | AgreementsControllerFindByType404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}